export const ALL_INCLUSIVE_PUSH = 'all-inclusive-push';
export const BRAND_PROMISE = 'brand-promise';
export const BRAND_SUPERIORITY = 'brand-superiority';
export const BUTTON_TICKET = 'button-ticket';
export const CHECKLIST = 'checklist';
export const COMPARISON_TABLE = 'comparison-table';
export const CRISIS_ALERT = 'crisis-alert';
export const CRUISE_BOOKING = 'cruise-booking';
export const CRUISE_PROGRAM = 'cruise-program';
export const DESTINATIONS = 'destinations';
export const DOWNLOAD_LINKS_LIST = 'download-links-list';
export const EDITORIAL_FOLDING_BLOCK = 'editorial-folding-block';
export const EVENT_ANIMATION = 'event-animation';
export const EVENT_FORM = 'event-form';
export const EVENT_FORM_AFFINITY = 'event-form-affinity';
export const EXCLUSIVE_COLLECTION_SPACE = 'exclusive-collection-space';
export const EXCLUSIVE_COLLECTION_SPACE_INTRODUCTION = 'exclusive-collection-space-introduction';
export const HAPPY_TO_CARE = 'happy-to-care';
export const HIGHLIGHT = 'highlight';
export const IMMERSIVE = 'immersive';
export const INSPIRATIONAL_GRID = 'inspirational-grid';
export const LAST_SEEN_PRODUCTS = 'last-seen-products';
export const MEDIA_TEXT_HORIZONTAL = 'media-text-horizontal';
export const MEDIA_TEXT_VERTICAL = 'media-text-vertical';
export const MEDIA_THUMBNAIL = 'media-thumbnail';
export const MUST_TRY_EXPERIENCES = 'must-try-experiences';
export const NAVIGATION_TAB = 'navigation-tab';
export const NAVIGATION_TABS = 'navigation-tabs';
export const OFFER_DESCRIPTION = 'offer-description';
export const OFFER_LEGAL_INFORMATION = 'offer-legal-information';
export const OFFER_SEO = 'offer-seo';
export const OFFERS_GRID = 'offers-grid';
export const OFFERS_PUSH = 'offers-push';
export const PAGE_TRACKING = 'page-tracking';
export const PREBOOKING_FORM = 'prebooking-form';
export const PRODUCT_ACTIVITIES = 'product-activities';
export const PRODUCT_BREADCRUMB = 'product-breadcrumb';
export const PRODUCT_CHILDCARES = 'product-childcares';
export const PRODUCT_IMAGE_MAP = 'product-image-map';
export const PRODUCT_IMMERSIVE = 'product-immersive';
export const PRODUCT_INFORMATION_SUMMARY = 'product-information-summary';
export const PRODUCT_SERVICES = 'product-services';
export const PRODUCT_SIGNATURES = 'product-signatures';
export const PRODUCT_STREET_VIEW = 'product-street-view';
export const PRODUCT_STRENGTHS = 'product-strengths';
export const PRODUCTS_FILTERS = 'products-filters';
export const PRODUCT_PRICE_TICKET_CUSTOM = 'product-price-ticket-custom';
export const PRODUCT_TAGS = 'product-tags';
export const QRCODE_PRODUCT_BARS = 'qrcode-product-bars';
export const QRCODE_PRODUCT_DRESSCODE = 'qrcode-product-dresscode';
export const QRCODE_PRODUCT_PROGRAM = 'qrcode-product-program';
export const QRCODE_PRODUCT_RESTAURANTS = 'qrcode-product-restaurants';
export const QUOTATION_FORM = 'quotation-form';
export const RELATED_PRODUCTS = 'related-products';
export const RESORT_ACCESS_AND_MAP = 'resort-access-and-map';
export const RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION = 'resort-accommodation-exclusivecollection';
export const RESORT_ACCOMMODATION_TYPES = 'resort-accommodationTypes';
export const RESORT_BARS = 'resort-bars';
export const RESORT_BOOKING_BE = 'resort-bookingBE';
export const RESORT_DESTINATION = 'resort-destination';
export const RESORT_DISTRICT = 'resort-district';
export const RESORT_FLASH_INFO = 'resort-flash-info';
export const RESORT_GRID = 'resort-grid';
export const RESORT_INTRODUCTION = 'resort-introduction';
export const RESORT_MEETING_ROOM_INFO = 'resort-meeting-room-info';
export const RESORT_MULTIMEDIA = 'resort-multimedia';
export const RESORT_PRICE_REMOTE = 'resort-price-remote';
export const RESORT_PRICE_TICKET = 'resort-price-ticket';
export const RESORT_RECOMMENDATIONS = 'resort-recommendations';
export const RESORT_RESTAURANTS = 'resort-restaurants';
export const RESORT_SEO = 'resort-seo';
export const RESORT_SUMMARY = 'resort-summary';
export const RESORT_TAGS = 'product-tags';
export const RESORT_TRIPADVISOR = 'resort-tripadvisor';
export const SECTION = 'section';
export const SECTIONS = 'sections';
export const SMART_FAQ = 'smart-faq';
export const SUBMISSION_STATUS = 'submission-status';
export const TAB = 'tab';
export const TABS = 'tabs';
export const TEASER_CARDS = 'teaser-cards';
export const TEST_AB = 'test-ab';
export const TEXT = 'text';
export const THEMATIC = 'thematic';
export const TITLE_AND_TEXT = 'title-and-text';
export const TRAVEL_RESTRICTIONS = 'travel-restrictions';
export const TOUR_INTRODUCTION = 'tour-introduction';
export const TOUR_PRACTICAL_INFORMATION = 'tour-practical-information';
export const TOUR_PROGRAM = 'tour-program';
export const TRIPADVISOR_TESTIMONY = 'tripadvisor-testimony';
export const VIDEO = 'video';
